export default __webpack_public_path__ + "static/media/iphone.89a3657f.png";